jQuery(document).ready(function ($) {
  /*--------------------------------------------------------------------------
   * Component: Modal
   *--------------------------------------------------------------------------
   */

  $(document.body).trigger('before_modal_init');

  var $modal = $('.c-modal');

  $.each($modal, function () {
    var $modalId = $(this).attr('data-modal-id');
    var $modalClass = 'c-modal.' + $modalId + '';
    var $modalOverlay = $('.c-modal-overlay.' + $modalId + '');
    console.log('Boom ' + $modalId);
    // console.log('Doom ' + $modalClass);

    $(document.body).on('updated_cart_totals', function () {
      console.log('Updated Cart');
      new modalClickAssign();
    });

    var modalClickAssign = function () {
      $(document.body).trigger('modal_init');

      $('.js-modal-toggle.' + $modalId + '').on('click', function (e) {
        e.preventDefault();
        console.log('Benny');
        $modalId = $(this).attr('data-modal-id');

        //var modalId = $(this).attr("data-modal-id");
        var cartId = $(this).attr('data-cart_id');
        if (cartId) {
          $('#penkeths_store_requisition_reject_form_requisition_id').val(
            cartId
          );
        }
        // toggle modal & overlay
        if ($(this).next('.c-modal-overlay.' + $modalId + '')) {
          $('.c-modal.' + $modalId + '').toggleClass('is-closed');
          $('.c-modal-overlay.' + $modalId + '').toggleClass('is-closed');
          $('.c-modal.' + $modalId + '').parent().removeClass('active');
        }

        // $(this).next().toggleClass('is-closed');
      });
    };

    new modalClickAssign();

    // // Close all modals and overlay when clicking on the overlay
    // $('.' + $modalClass + '')
    //   .next()
    //   .on('click', function (e) {
    //     $(this).addClass('is-closed').prev().addClass('is-closed');
    //   });
    $('.c-modal-overlay').on('click', function (e) {
      $(this).addClass('is-closed');
      $(this).prev('.c-modal').addClass('is-closed');
      $(this).prev('.c-modal').parent().removeClass('active');
    });

    // Close modal via close button
    // $('.' + $modalClass + '')
    //   .find('.js-modal-toggle-close')
    //   .on('click', function (e) {
    //     $modalOverlay.addClass('is-closed');
    //     $('.' + $modalClass + '').addClass('is-closed');
    //   });
    $('.js-modal-toggle-close').on('click', function (e) {
      $('.c-modal-overlay').addClass('is-closed');
      $('.c-modal').addClass('is-closed');
      $('.c-modal').parent().removeClass('active');
    });
  });

  $(document.body).trigger('after_modal_init');
});

function modalToggleClose(e) {
  jQuery('.c-modal-overlay').addClass('is-closed');
  jQuery('.c-modal').addClass('is-closed');
  jQuery('.c-modal').parent().removeClass('active');
}